import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  requireModuleSelection: false, // Set to false to skip module selection
};

const moduleSelectionSlice = createSlice({
  name: "moduleSelection",
  initialState,
  reducers: {
    setRequireModuleSelection: (state, action) => {
      state.requireModuleSelection = action.payload;
    },
    toggleModuleSelection: (state) => {
      state.requireModuleSelection = !state.requireModuleSelection;
    },
  },
});

export const { setRequireModuleSelection, toggleModuleSelection } =
  moduleSelectionSlice.actions;
export default moduleSelectionSlice.reducer;
